import { Avatar } from '@/components/Avatar/Avatar'
import CheckSvg from '@/icons/check.svg?react'
import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const RepoCommitUI: FunctionalComponent<{
  selected?: boolean
  message: string
  onToggle: (message: string) => void
}> = props => {
  return (
    <div class={styles.wrapper}>
      <div
        class={classNames(styles.root)}
        onClick={() => {
          props.onToggle(props.message)
        }}
      >
        <div class={styles.title}>
          <div
            className={classNames(styles.check, {
              [styles.selected]: props.selected,
            })}
          >
            <CheckSvg />
          </div>

          <Avatar
            size={16}
          />

          <div class={styles.message}>
            {props.message}
          </div>
        </div>
      </div>
    </div>
  )
}
